import { ElementRef } from '@angular/core';
import { Component, OnInit, HostBinding, Input, Output, EventEmitter, OnDestroy } from '@angular/core';

@Component({
  selector: 'mobile-footer',
  template: require('./mobile-footer.component.html'),
  styles: [require('./mobile-footer.component.css')]
})
export class MobileFooterComponent implements OnInit, OnDestroy {


  static DEFAULT_HEIGHT = '85px';

  @HostBinding('style.height')
  protected _height?: string;

  @Input()
  set height(value: string | undefined)
  {
    if(this._height == value)
      return;

    this._height = value;
    this.heightChanged.emit(value);
    try
    {
      if(this.autosetPaddingBottom)
       this.elementRef.nativeElement.parentElement.style.paddingBottom = value;
    }
    catch(e)
    {
      console.log(e);
    }
  }

  @Input()
  autosetPaddingBottom = true;

  @Output()
  heightChanged: EventEmitter<string | undefined> = new EventEmitter();

  constructor(protected elementRef: ElementRef) { }

  ngOnInit() {
    if(this._height == undefined) 
      this.height = MobileFooterComponent.DEFAULT_HEIGHT;
  }

  ngOnDestroy (): void {
    this.height = '0px';
  }
}
